/* eslint-disable */
/**
 * tslint:disable
 * Generated by orval 🍺
 * Do not edit manually.
 * DHL Identity Manager
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { useCallback } from 'react'
import type {
  BadRequest,
  ErrorInfo,
  Forbidden,
  NotFound,
  PostUser,
  Role,
  SearchRolesParams,
  SearchUsersParams,
  Unauthorized,
  User,
} from '.././model'
import { useMutator } from '../../useMutator'
import type { ErrorType } from '../../useMutator'

/**
 * Query all users
 */
export const useSearchUsersHook = () => {
  const searchUsers = useMutator<User[]>()

  return useCallback(
    (params?: SearchUsersParams, signal?: AbortSignal) => {
      return searchUsers({ url: `/users`, method: 'GET', params, signal })
    },
    [searchUsers]
  )
}

export const getSearchUsersQueryKey = (params?: SearchUsersParams) => {
  return [`/users`, ...(params ? [params] : [])] as const
}

export const useSearchUsersQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useSearchUsersHook>>>,
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
>(
  params?: SearchUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSearchUsersHook>>>, TError, TData>>
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getSearchUsersQueryKey(params)

  const searchUsers = useSearchUsersHook()

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useSearchUsersHook>>>> = ({ signal }) =>
    searchUsers(params, signal)

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useSearchUsersHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchUsersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSearchUsersHook>>>>
export type SearchUsersQueryError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>

export function useSearchUsers<
  TData = Awaited<ReturnType<ReturnType<typeof useSearchUsersHook>>>,
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
>(
  params: undefined | SearchUsersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSearchUsersHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSearchUsersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSearchUsersHook>>>
        >,
        'initialData'
      >
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchUsers<
  TData = Awaited<ReturnType<ReturnType<typeof useSearchUsersHook>>>,
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
>(
  params?: SearchUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSearchUsersHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSearchUsersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSearchUsersHook>>>
        >,
        'initialData'
      >
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchUsers<
  TData = Awaited<ReturnType<ReturnType<typeof useSearchUsersHook>>>,
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
>(
  params?: SearchUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSearchUsersHook>>>, TError, TData>>
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useSearchUsers<
  TData = Awaited<ReturnType<ReturnType<typeof useSearchUsersHook>>>,
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
>(
  params?: SearchUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSearchUsersHook>>>, TError, TData>>
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = useSearchUsersQueryOptions(params, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Create a user
 */
export const useNewUserHook = () => {
  const newUser = useMutator<User>()

  return useCallback(
    (postUser: PostUser, signal?: AbortSignal) => {
      return newUser({
        url: `/users`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: postUser,
        signal,
      })
    },
    [newUser]
  )
}

export const useNewUserMutationOptions = <
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useNewUserHook>>>,
    TError,
    { data: PostUser },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useNewUserHook>>>,
  TError,
  { data: PostUser },
  TContext
> => {
  const mutationKey = ['newUser']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const newUser = useNewUserHook()

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useNewUserHook>>>, { data: PostUser }> = (
    props
  ) => {
    const { data } = props ?? {}

    return newUser(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type NewUserMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useNewUserHook>>>>
export type NewUserMutationBody = PostUser
export type NewUserMutationError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>

export const useNewUser = <
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useNewUserHook>>>,
    TError,
    { data: PostUser },
    TContext
  >
}): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useNewUserHook>>>, TError, { data: PostUser }, TContext> => {
  const mutationOptions = useNewUserMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Count all users
 */
export const useCountUsersHook = () => {
  const countUsers = useMutator<number>()

  return useCallback(
    (signal?: AbortSignal) => {
      return countUsers({ url: `/users/count`, method: 'GET', signal })
    },
    [countUsers]
  )
}

export const getCountUsersQueryKey = () => {
  return [`/users/count`] as const
}

export const useCountUsersQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useCountUsersHook>>>,
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountUsersHook>>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getCountUsersQueryKey()

  const countUsers = useCountUsersHook()

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useCountUsersHook>>>> = ({ signal }) =>
    countUsers(signal)

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useCountUsersHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> }
}

export type CountUsersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCountUsersHook>>>>
export type CountUsersQueryError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>

export function useCountUsers<
  TData = Awaited<ReturnType<ReturnType<typeof useCountUsersHook>>>,
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountUsersHook>>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<ReturnType<typeof useCountUsersHook>>>,
        TError,
        Awaited<ReturnType<ReturnType<typeof useCountUsersHook>>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCountUsers<
  TData = Awaited<ReturnType<ReturnType<typeof useCountUsersHook>>>,
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountUsersHook>>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<ReturnType<typeof useCountUsersHook>>>,
        TError,
        Awaited<ReturnType<ReturnType<typeof useCountUsersHook>>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCountUsers<
  TData = Awaited<ReturnType<ReturnType<typeof useCountUsersHook>>>,
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountUsersHook>>>, TError, TData>>
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useCountUsers<
  TData = Awaited<ReturnType<ReturnType<typeof useCountUsersHook>>>,
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCountUsersHook>>>, TError, TData>>
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = useCountUsersQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Get user by id
 */
export const useGetUserHook = () => {
  const getUser = useMutator<User>()

  return useCallback(
    (p1: string, signal?: AbortSignal) => {
      return getUser({ url: `/users/${p1}`, method: 'GET', signal })
    },
    [getUser]
  )
}

export const getGetUserQueryKey = (p1: string) => {
  return [`/users/${p1}`] as const
}

export const useGetUserQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>,
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
>(
  p1: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetUserQueryKey(p1)

  const getUser = useGetUserHook()

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>> = ({ signal }) =>
    getUser(p1, signal)

  return { queryKey, queryFn, enabled: !!p1, staleTime: 10000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>>
export type GetUserQueryError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>

export function useGetUser<
  TData = Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>,
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
>(
  p1: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>
        >,
        'initialData'
      >
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUser<
  TData = Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>,
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
>(
  p1: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>
        >,
        'initialData'
      >
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUser<
  TData = Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>,
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
>(
  p1: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData>> }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetUser<
  TData = Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>,
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
>(
  p1: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData>> }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = useGetUserQueryOptions(p1, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Assign roles to a user
 */
export const usePostRolesHook = () => {
  const postRoles = useMutator<void>()

  return useCallback(
    (p1: string, postRolesBody?: string[], signal?: AbortSignal) => {
      return postRoles({
        url: `/users/${p1}/roles`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: postRolesBody,
        signal,
      })
    },
    [postRoles]
  )
}

export const usePostRolesMutationOptions = <
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostRolesHook>>>,
    TError,
    { p1: string; data: string[] },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof usePostRolesHook>>>,
  TError,
  { p1: string; data: string[] },
  TContext
> => {
  const mutationKey = ['postRoles']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const postRoles = usePostRolesHook()

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePostRolesHook>>>,
    { p1: string; data: string[] }
  > = (props) => {
    const { p1, data } = props ?? {}

    return postRoles(p1, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostRolesMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostRolesHook>>>>
export type PostRolesMutationBody = string[]
export type PostRolesMutationError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>

export const usePostRoles = <
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostRolesHook>>>,
    TError,
    { p1: string; data: string[] },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof usePostRolesHook>>>,
  TError,
  { p1: string; data: string[] },
  TContext
> => {
  const mutationOptions = usePostRolesMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Search roles
 */
export const useSearchRolesHook = () => {
  const searchRoles = useMutator<Role[]>()

  return useCallback(
    (params?: SearchRolesParams, signal?: AbortSignal) => {
      return searchRoles({ url: `/roles`, method: 'GET', params, signal })
    },
    [searchRoles]
  )
}

export const getSearchRolesQueryKey = (params?: SearchRolesParams) => {
  return [`/roles`, ...(params ? [params] : [])] as const
}

export const useSearchRolesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useSearchRolesHook>>>,
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
>(
  params?: SearchRolesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSearchRolesHook>>>, TError, TData>>
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getSearchRolesQueryKey(params)

  const searchRoles = useSearchRolesHook()

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useSearchRolesHook>>>> = ({ signal }) =>
    searchRoles(params, signal)

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useSearchRolesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchRolesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSearchRolesHook>>>>
export type SearchRolesQueryError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>

export function useSearchRoles<
  TData = Awaited<ReturnType<ReturnType<typeof useSearchRolesHook>>>,
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
>(
  params: undefined | SearchRolesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSearchRolesHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSearchRolesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSearchRolesHook>>>
        >,
        'initialData'
      >
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchRoles<
  TData = Awaited<ReturnType<ReturnType<typeof useSearchRolesHook>>>,
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
>(
  params?: SearchRolesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSearchRolesHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSearchRolesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSearchRolesHook>>>
        >,
        'initialData'
      >
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchRoles<
  TData = Awaited<ReturnType<ReturnType<typeof useSearchRolesHook>>>,
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
>(
  params?: SearchRolesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSearchRolesHook>>>, TError, TData>>
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useSearchRoles<
  TData = Awaited<ReturnType<ReturnType<typeof useSearchRolesHook>>>,
  TError = ErrorType<BadRequest | Unauthorized | Forbidden | NotFound | ErrorInfo>,
>(
  params?: SearchRolesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSearchRolesHook>>>, TError, TData>>
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = useSearchRolesQueryOptions(params, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

  query.queryKey = queryOptions.queryKey

  return query
}

export const useGetStatusHook = () => {
  const getStatus = useMutator<string>()

  return useCallback(
    (signal?: AbortSignal) => {
      return getStatus({ url: `/status`, method: 'GET', signal })
    },
    [getStatus]
  )
}

export const getGetStatusQueryKey = () => {
  return [`/status`] as const
}

export const useGetStatusQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetStatusQueryKey()

  const getStatus = useGetStatusHook()

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>> = ({ signal }) =>
    getStatus(signal)

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> }
}

export type GetStatusQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>>
export type GetStatusQueryError = ErrorType<unknown>

export function useGetStatus<
  TData = Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>,
        TError,
        Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetStatus<
  TData = Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>,
        TError,
        Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetStatus<
  TData = Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>, TError, TData>>
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetStatus<
  TData = Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStatusHook>>>, TError, TData>>
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = useGetStatusQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

  query.queryKey = queryOptions.queryKey

  return query
}
